module.exports = __webpack_public_path__ + "static/media/report_1-10_mobile.4d282619.png";